$(document).ready(function(){
  var reso = window.screen.availWidth;
  $("header").css("box-shadow", "0 20px 50px 30px #000");
$(window).scroll(function (event) {
    var scroll = $(window).scrollTop();
  if(scroll > 100){
    $("header").css("box-shadow", "none");
  } else {
    $("header").css("box-shadow", "0 20px 50px 30px #000");
  }
});

  if(reso < 1000){
  $(".mobile-header-button").click(function(){
    $(".header nav").css("display", "block");
    $(".mobile-header-logo").hide();
  });

  $(".header nav > *").click(function(){
    $(".header nav").fadeOut();
    $(".mobile-header-logo").show();
  });

  $(".list-menu li a").click(function(){
    $(".header__inline-menu").css("display", "block");
  })
    }
});

